import { HttpError } from "@bps/http-client";

export class NetworkError extends HttpError {}
